import { Container, Text } from '@sparemin/blockhead';
import React from 'react';
import styles from './TldlSearchModalBanner.module.scss';

export interface TldlSearchModalBannerProps {}

const TldlSearchModalBanner: React.FC<TldlSearchModalBannerProps> = () => (
  <Container
    className={styles.banner}
    borderWeight={0}
    cornerRadius={0}
    gutter="24px 24px 0"
  >
    <Text
      className={styles.instructions}
      letterSpacing={1.2}
      textTransform="uppercase"
      variant="p"
    >
      select episodes to summarize
    </Text>
  </Container>
);

export default TldlSearchModalBanner;
